
import React from "react";
import Layout from "@/components/layout/Layout";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

interface ErrorStateProps {
  error: Error | null;
}

export function OwnerPageErrorState({ error }: ErrorStateProps) {
  return (
    <Layout>
      <div className="container py-8">
        <Card>
          <CardContent className="p-6">
            <div className="flex flex-col items-center justify-center text-center">
              <AlertCircle className="h-12 w-12 text-red-500 mb-4" />
              <h2 className="text-2xl font-bold mb-2">Error Loading Data</h2>
              <p className="text-muted-foreground mb-4">
                {error?.message || "Failed to load nursing home details"}
              </p>
              <Button onClick={() => window.location.reload()}>
                Try Again
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
